<template>
    <div class="container-fluid">
        <div class="row ml-4 mr-4 mb-4 border-bottom">
            <h2>Preferences</h2>
            <div class="ml-auto">
                <button type="button" class="btn btn-primary btn-sm" @click="save()"><i class="fas fa-save"></i></button>
            </div>            
        </div>
        <div class="m-4">
            <h4 class="border-bottom mr-5">General</h4>
            <div class="m-3">
                <div v-if="roles.length > 1" class="form-group">
                    <label for="default-role" class="d-inline mr-2">Default Role</label>
                    <select id="default-role" class="custom-select custom-select-sm"  style="width:auto" v-model="defaultRoleId">
                        <option v-for="role in roles" :key="'role-option-' + role.id" :value="role.id">{{ role.name }}</option>
                    </select>
                </div>
                <div class="form-group">
                    <label for="items-per-page" class="mr-2" style="display: inline">Items Per Page</label>
                    <input id="items-per-page" type="number" style="width:75px;display: inline" class="form-control form-control-sm" min="5" step="5" v-model="itemsPerPage" required>
                </div>
            </div>
            <div v-if="notifications.length">     
                <h4 class="border-bottom mr-5">Notifications</h4>
                <div class="form-group m-3">
                    <div v-for="notification in notifications" :key="notification.id" class="custom-control custom-checkbox">
                        <input class="custom-control-input" type="checkbox" :id="'notification-' + notification.id" v-model="notification.checked" true-value="1" false-value="0">
                        <label class="custom-control-label" :for="'notification-' + notification.id">{{ notification.name }}</label>                     
                        <select v-if="notification.type == 'periodic'" class="custom-select custom-select-sm" style="width:auto" name="" v-model="notification.param">
                            <option value="daily">Daily</option>
                            <option value="weekly">Weekly</option>
                            <option value="monthly">Monthly</option>
                            <option value="quarterly">Quarterly</option>                        
                        </select>                                          
                    </div>
                </div>
            </div>
            <h4 class="border-bottom mr-5">Claim Document Sections</h4>
            <div v-if="visible['general']" class="form-group row">
                <div class="col-md-2">Claim Information</div>
                <div class="col-md-2 btn-group btn-group-sm btn-group-toggle">
                    <label :class="['btn btn-secondary', {'active': generalCollapsed == 0}]">
                        <input type="radio" value="0" autocomplete="off" v-model="generalCollapsed"> Expanded
                    </label>                        
                    <label :class="['btn btn-secondary', {'active': generalCollapsed == 1}]">
                        <input type="radio" value="1" autocomplete="off" v-model="generalCollapsed"> Collapsed
                    </label>                
                </div>
            </div>
            <div v-if="visible['compensation-disputes']" class="form-group row">
                <div class="col-md-2">Compensation Disputes</div>
                <div class="col-md-2 btn-group btn-group-sm btn-group-toggle">
                    <label :class="['btn btn-secondary', {'active': compensationDisputesCollapsed == 0}]">
                        <input type="radio" value="0" autocomplete="off" v-model="compensationDisputesCollapsed"> Expanded
                    </label>                        
                    <label :class="['btn btn-secondary', {'active': compensationDisputesCollapsed == 1}]">
                        <input type="radio" value="1" autocomplete="off" v-model="compensationDisputesCollapsed"> Collapsed
                    </label>                
                </div>
            </div>              
            <div v-if="visible['responses']" class="form-group row">
                <div class="col-md-2">Received Correspondence</div>
                <div class="col-md-2 btn-group btn-group-sm btn-group-toggle">
                    <label :class="['btn btn-secondary', {'active': responsesCollapsed == 0}]">
                        <input type="radio" value="0" autocomplete="off" v-model="responsesCollapsed"> Expanded
                    </label>                        
                    <label :class="['btn btn-secondary', {'active': responsesCollapsed == 1}]">
                        <input type="radio" value="1" autocomplete="off" v-model="responsesCollapsed"> Collapsed
                    </label>                
                </div>
            </div>                                       
            <div v-if="visible['authorizations']" class="form-group row mt-3">
                <div class="col-md-2">Requests For Authorization</div>
                <div class="col-md-2 btn-group btn-group-sm btn-group-toggle">
                    <label :class="['btn btn-secondary', {'active': authsCollapsed == 0}]">
                        <input type="radio" value="0" autocomplete="off" v-model="authsCollapsed"> Expanded
                    </label>                    
                    <label :class="['btn btn-secondary', {'active': authsCollapsed == 1}]">
                        <input type="radio" value="1" autocomplete="off" v-model="authsCollapsed"> Collapsed
                    </label>                    
                </div>
            </div>
            <div v-if="visible['medical-treatment-disputes']" class="form-group row">
                <div class="col-md-2">Medical Treatment Disputes</div>
                <div class="col-md-2 btn-group btn-group-sm btn-group-toggle">
                    <label :class="['btn btn-secondary', {'active': medicalTreatmentDisputesCollapsed == 0}]">
                        <input type="radio" value="0" autocomplete="off" v-model="medicalTreatmentDisputesCollapsed"> Expanded
                    </label>                        
                    <label :class="['btn btn-secondary', {'active': medicalTreatmentDisputesCollapsed == 1}]">
                        <input type="radio" value="1" autocomplete="off" v-model="medicalTreatmentDisputesCollapsed"> Collapsed
                    </label>                
                </div>
            </div>            
            <div v-if="visible['services']" class="form-group row">
                <div class="col-md-2">Health Insurance Claim Forms</div>
                <div class="col-md-2 btn-group btn-group-sm btn-group-toggle">
                    <label :class="['btn btn-secondary', {'active': servicesCollapsed == 0}]">
                        <input type="radio" value="0" autocomplete="off" v-model="servicesCollapsed"> Expanded
                    </label>                     
                    <label :class="['btn btn-secondary', {'active': servicesCollapsed == 1}]">
                        <input type="radio" value="1" autocomplete="off" v-model="servicesCollapsed"> Collapsed
                    </label>                   
                </div>
            </div>
            <div v-if="visible['other']" class="form-group row">
                <div class="col-md-2">Other Documents</div>
                <div class="col-md-2 btn-group btn-group-sm btn-group-toggle">
                    <label :class="['btn btn-secondary', {'active': othersCollapsed == 0}]">
                        <input type="radio" value="0" autocomplete="off" v-model="othersCollapsed"> Expanded
                    </label>                        
                    <label :class="['btn btn-secondary', {'active': othersCollapsed == 1}]">
                        <input type="radio" value="1" autocomplete="off" v-model="othersCollapsed"> Collapsed
                    </label>                
                </div>
            </div>                      
        </div>
    </div>    
</template>

<script>
export default {
    data() {
        return {
            roles: [],
            defaultRoleId: null,
            itemsPerPage: 15,
            notifications: [],
            selectedNotifications: [],
            visible: [],
            generalCollapsed: null,
            responsesCollapsed: null,
            authsCollapsed: null,
            servicesCollapsed: null,
            othersCollapsed: null,
            medicalTreatmentDisputesCollapsed: null,
            compensationDisputesCollapsed: null
        }
    },
    methods: {
        save: function () {
            axios.patch('/ajax/user/preferences', {
                'default_role_id': this.defaultRoleId,
                'items_per_page': this.itemsPerPage,
                'notifications': this.notifications,
                'general_collapsed': this.generalCollapsed,
                'responses_collapsed': this.responsesCollapsed,
                'authorizations_collapsed': this.authsCollapsed,
                'services_collapsed': this.servicesCollapsed,
                'others_collapsed': this.othersCollapsed,
                'medical_treatment_disputes_collapsed': this.medicalTreatmentDisputesCollapsed,
                'compensation_disputes_collapsed': this.compensationDisputesCollapsed
            })
            .then(response => {
                toastr[response.data.level](response.data.message, response.data.title, { timeOut: 10000, positionClass: "toast-top-full-width", closeButton: true });
            })
            .catch(error => {
                toastr[error.response.data.level](error.response.data.message, error.response.data.title, { timeOut: 10000, positionClass: "toast-top-full-width", closeButton: true });    
            })
        }
    },
    created() {
        axios.get('/ajax/user/preferences')
            .then(response => {
                this.roles = response.data.roles;
                this.defaultRoleId = response.data.defaultRoleId;
                this.itemsPerPage = response.data.itemsPerPage;
                this.notifications = response.data.notifications;
                this.visible = response.data.visible,
                this.generalCollapsed = response.data.generalCollapsed.toString();
                this.responsesCollapsed = response.data.responsesCollapsed.toString();
                this.authsCollapsed = response.data.authorizationsCollapsed.toString();
                this.servicesCollapsed = response.data.servicesCollapsed.toString();
                this.othersCollapsed = response.data.othersCollapsed.toString();
                this.medicalTreatmentDisputesCollapsed = response.data.medicalTreatmentDisputesCollapsed.toString();
                this.compensationDisputesCollapsed = response.data.compensationDisputesCollapsed.toString();
            })
            .catch(error => {
                console.log(error.response.data);
            });
    }    
}
</script>

<style scoped>
    .btn-group .btn.active {
        background-color: #0a578a;
    }
</style>